var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg9104258HomeHouseHomepageIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 20.9997H17C19.2 20.9997 21 19.1997 21 16.9997V10.4997C21 9.19967 20.4 8.09967 19.4 7.29967L14.4 3.49967C13 2.49967 11 2.49967 9.6 3.59967L4.6 7.29967C3.6 8.09967 3 9.19967 3 10.4997V16.9997C3 19.1997 4.8 20.9997 7 20.9997ZM5 10.4997C5 9.89967 5.3 9.29966 5.8 8.89966L10.8 5.09967C11.2 4.79967 11.6 4.69967 12 4.69967C12.4 4.69967 12.8 4.79967 13.2 5.09967L18.2 8.89966C18.7 9.29966 19 9.89967 19 10.4997V16.9997C19 18.0997 18.1 18.9997 17 18.9997H7C5.9 18.9997 5 18.0997 5 16.9997V10.4997Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9104258HomeHouseHomepageIcon1);
export default __webpack_public_path__ + "static/media/9104258_home_house_homepage_icon 1.24080214f7040ec360dc68d501fcadf3.svg";
export { ForwardRef as ReactComponent };